module.exports = __webpack_public_path__ + "img/star_4.f3bff63a.jpg";